import React, { useState, useEffect, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Translate, withLocalize } from 'react-localize-redux'
import { IconButton, Table, TableBody } from '@material-ui/core'
import { Card } from 'components'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import {
  SubLink,
  CategoryForManageCategories,
  LanguageSelectorForAdmins,
} from 'containers'
import { articles } from 'redux/modules'
import { createSubUrl } from 'utils/urlConstructor'
import PropTypes from 'prop-types'
import { ARTICLES_DASHBOARD_ROUTE } from 'constants/routes'

const MAX_DEPTH = 2

// @todo: #roles protect route or move functionality outside
const ArticlesCategoriesContainer = ({
  location: { fromUrl },
  match,
  articlesCategories,
  createArticlesCategory,
  updateArticlesCategory,
  deleteArticlesCategory,
  activeLanguage,
  clubUuid,
}) => {
  const [articlesCategoriesState, changeArticlesCategoriesState] = useState([])

  useEffect(() => {
    changeArticlesCategoriesState(articlesCategories)
  }, [articlesCategories])

  const linkBack = fromUrl || createSubUrl(match, ARTICLES_DASHBOARD_ROUTE)

  const addNewCategory = (parentId) => (title, image) => {
    createArticlesCategory({
      title,
      image,
      parent_id: parentId,
    })
  }

  const Categories = ({ depth, parentId, currentClubUuid }) => (
    <>
      {articlesCategoriesState
        .filter(
          (category) =>
            category.parent_id === parentId &&
            category.club_uuid === currentClubUuid
        )
        .map((category) => (
          <Fragment key={category.id}>
            <CategoryForManageCategories
              depth={depth}
              category={category}
              activeLocale={activeLanguage.code}
              updateCategory={updateArticlesCategory}
              deleteCategory={deleteArticlesCategory}
            />
            {depth < MAX_DEPTH && (
              <Categories
                depth={depth + 1}
                parentId={category.id}
                currentClubUuid={currentClubUuid}
              />
            )}
          </Fragment>
        ))}
      <CategoryForManageCategories.New
        depth={depth}
        addNewCategory={addNewCategory(parentId)}
      />
    </>
  )

  Categories.defaultProps = {
    parentId: null,
  }

  Categories.propTypes = {
    depth: PropTypes.number.isRequired,
    parentId: PropTypes.string,
    currentClubUuid: PropTypes.string.isRequired,
  }

  return (
    <Card>
      <Card.Title className="d-flex justify-content-between">
        <SubLink to={linkBack} isFullPath>
          <IconButton edge="start" color="inherit">
            <ArrowBackIcon fontSize="inherit" />
          </IconButton>
        </SubLink>
        <div>
          <Translate id="drills.manage-categories" />
          <LanguageSelectorForAdmins />
        </div>
      </Card.Title>
      <Table>
        <TableBody>
          <Categories depth={0} parentId={null} currentClubUuid={clubUuid} />
        </TableBody>
      </Table>
    </Card>
  )
}

ArticlesCategoriesContainer.defaultProps = {
  articlesCategories: [],
}

ArticlesCategoriesContainer.propTypes = {
  location: PropTypes.shape({
    fromUrl: PropTypes.string,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.objectOf(PropTypes.string).isRequired,
  }).isRequired,
  articlesCategories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      parent_id: PropTypes.string,
    })
  ),
  createArticlesCategory: PropTypes.func.isRequired,
  updateArticlesCategory: PropTypes.func.isRequired,
  deleteArticlesCategory: PropTypes.func.isRequired,
  activeLanguage: PropTypes.shape().isRequired,
  clubUuid: PropTypes.string.isRequired,
}

export default compose(
  connect(
    ({
      articles: {
        current: { articlesCategories },
      },
      clubs,
    }) => ({
      articlesCategories,
      clubUuid: clubs.current.uuid,
    }),
    {
      createArticlesCategory: articles.createArticlesCategory,
      updateArticlesCategory: articles.updateArticlesCategory,
      deleteArticlesCategory: articles.deleteArticlesCategory,
    }
  ),
  withLocalize
)(ArticlesCategoriesContainer)
